
import Error from "@/components/Error.vue";
import useOidc from "@/composables/useOidc";
import { isValidGuid } from "@/composables/utils";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Error },

  setup() {
    const oidc = useOidc();
    const hasUserProfile = isValidGuid(oidc.user.value?.profile?.sub);
    const authHeader = oidc.user.value?.access_token;

    // extract Payload of access_token
    const payload = authHeader
      ? JSON.parse(decodeURIComponent(escape(atob(authHeader.split(".")[1]))))
      : null;

    if (payload) {
      for (const key in payload) {
        if (typeof payload[key] === "string" && payload[key].startsWith("[")) {
          try {
            const parsed = JSON.parse(payload[key]);
            if (Array.isArray(parsed)) {
              payload[key] = parsed;
            }
          } catch (error) {
            // not a valid JSON array, leave as is
            console.log(error);
          }
        }
      }
    }

    return {
      payload,
      hasUserProfile,
    };
  },
});
